import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import React from 'react'
import TermsModalViewModel from './TermsModalViewModel'
import styles from './TermsModal.sass'
import Button from 'components/Button'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: TermsModalViewModel
}

export default observer(function TermsModal({ vm }: Props) {
  return (
    <ModalSheet
      showing={vm.showing}
      disableCloseOnEsc
      disableCloseOnOutsideClick
    >
      <ModalSheetHeader bordered>
        <ModalSheetTitle>Terms Of Use</ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        {
          <div
            className={styles.termsFrameContent}
            dangerouslySetInnerHTML={{ __html: vm.termsContent }}
          />
        }
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={async () => vm.accept()} type="primary">
            Accept
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
